/**
 * مسیرهای پنل به صورت متمرکز برای جلوگیری از hardcode شدن.
 */
export const ROUTES = {
  ROOT: '/',
  DASHBOARD: '/dashboard',
  MEETINGS: '/meetings',
  MEETING_GROUPS: '/meeting-groups',
  MEETINGS_NEW: '/meetings/new',
  AGENDAS: '/agendas',
  AGENDAS_NEW: '/agendas/new',
  AGENDA_TEMPLATES: '/agenda-templates',
  AGENDA_TEMPLATES_NEW: '/agenda-templates/new',
  AGENDA_TEMPLATES_MARKETPLACE: '/agenda-templates/marketplace',
  FILES: '/files',
  ACTION_ITEMS: '/action-items',
  ACTION_ITEMS_NEW: '/action-items/new',
  MINUTES: '/minutes',
  MINUTES_NEW: '/minutes/new',
  STT_JOBS: '/stt/jobs',
  TRANSCRIPTS: '/transcripts',
  WEBHOOK_DEAD_LETTERS: '/webhooks/dead-letters',
  AUDIT_EVENTS: '/activity-history',
  ROOMS: '/rooms',
  ROOMS_NEW: '/rooms/new',
  CALENDAR: '/calendar',
  ANNOUNCEMENTS: '/announcements',
  NOTIFICATIONS: '/notifications',
  USERS: '/users',
  USERS_NEW: '/users/new',
  PLATFORM_ADMINS: '/users/platform-admins',
  SYSTEM_ORGANIZATION_ROLES: '/settings/system-organization-roles',
  ROLES_AND_PERMISSIONS: '/settings/roles-and-permissions',
  REPORTS: '/reports',
  SETTINGS: '/settings',
  BILLING: '/billing',
  BILLING_CALLBACK: '/billing/callback',
  SEARCH: '/search',
  PROFILE: '/profile',
  /** امنیت حساب کاربری (رمز، عامل دوم، نشست‌ها) */
  SECURITY: '/security',
  /** ایجاد فضای کاری شخصی */
  PERSONAL_WORKSPACE_NEW: '/profile/personal-workspace',
  /** تنظیمات سازمان فعال (tenant) */
  WORKSPACE: '/workspace',
  /** مدیریت سازمان‌ها (لیست + جزئیات) */
  ORGANIZATIONS: '/organizations',
  /** اعضای سازمان فعال (tenant) */
  ORG_MEMBERS: '/members',
  /** نقش‌ها و دسترسی‌های سازمان فعال (tenant) */
  ORG_ROLES: '/roles',
  ORGANIZATIONS_NEW: '/organizations/new',
  LOGIN: '/login',
  REGISTER: '/register',
  NOT_FOUND: '*',
};

/** مسیر جزئیات یک سازمان — تب اختیاری با query string */
export const organizationDetailPath = (orgId, tab) => {
  const base = `/organizations/${encodeURIComponent(String(orgId))}`;
  if (!tab || tab === 'overview') return base;
  return `${base}?tab=${encodeURIComponent(String(tab))}`;
};

/** مسیر ویرایش یک سازمان */
export const organizationEditPath = (orgId) => `/organizations/${encodeURIComponent(String(orgId))}/edit`;

/** مسیر اعضای یک دپارتمان */
export const organizationDepartmentMembersPath = (orgId, deptId, mode = 'view') => {
  const base = `/organizations/${encodeURIComponent(String(orgId))}/departments/${encodeURIComponent(String(deptId))}/members`;
  return mode === 'edit' ? `${base}?mode=edit` : base;
};

/** مسیر صفحهٔ عمومی دعوت */
export const invitePath = (token) => `/invite/${encodeURIComponent(String(token))}`;

/** مسیر جزئیات یک جلسه؛ با tab مثلاً minutes و section مثلاً actions برای زیرتب */
export const meetingDetailPath = (meetingId, tab, section) => {
  const base = `/meetings/${encodeURIComponent(String(meetingId))}`;
  const params = new URLSearchParams();
  if (tab) params.set('tab', tab);
  if (section) params.set('section', section);
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
};

/** مسیر ویرایش یک جلسه */
export const meetingEditPath = (meetingId) => `/meetings/${encodeURIComponent(String(meetingId))}/edit`;

export const meetingGroupDetailPath = (groupId) => `/meeting-groups/${encodeURIComponent(String(groupId))}`;

/** مسیر فایل‌های ضبط یک رکورد BBB */
export const meetingRecordingAssetsPath = (meetingId, recordId) =>
  `/meetings/${encodeURIComponent(String(meetingId))}/recordings/${encodeURIComponent(String(recordId))}/assets`;

/** مسیر رخدادهای ضبط یک رکورد BBB */
export const meetingRecordingEventsPath = (meetingId, recordId) =>
  `/meetings/${encodeURIComponent(String(meetingId))}/recordings/${encodeURIComponent(String(recordId))}/events`;

/** مرحلهٔ شرکت‌کنندگان در ویزارد ویرایش جلسه */
export const meetingEditPeoplePath = (meetingId) =>
  `${meetingEditPath(meetingId)}?step=people`;

/** مسیر جزئیات دستور جلسه */
export const agendaDetailPath = (agendaId) => `/agendas/${encodeURIComponent(String(agendaId))}`;

/** مسیر جزئیات قالب دستور جلسه */
export const agendaTemplateDetailPath = (templateId) =>
  `/agenda-templates/${encodeURIComponent(String(templateId))}`;

/** مسیر ویرایش قالب دستور جلسه */
export const agendaTemplateEditPath = (templateId) =>
  `/agenda-templates/${encodeURIComponent(String(templateId))}/edit`;

/** مسیر جزئیات فایل */
export const fileDetailPath = (fileId) => `/files/${encodeURIComponent(String(fileId))}`;

export const actionItemDetailPath = (id) => `/action-items/${encodeURIComponent(String(id))}`;
export const actionItemEditPath = (id) => `/action-items/${encodeURIComponent(String(id))}/edit`;
export const actionItemPrintPath = (id) => `/action-items/${encodeURIComponent(String(id))}/print`;
export const minuteDetailPath = (id) => `/minutes/${encodeURIComponent(String(id))}`;
export const sttJobDetailPath = (id) => `/stt/jobs/${encodeURIComponent(String(id))}`;
export const transcriptDetailPath = (id) => `/transcripts/${encodeURIComponent(String(id))}`;

export const roomDetailPath = (roomId, tab) => {
  const base = `/rooms/${encodeURIComponent(String(roomId))}`;
  return tab ? `${base}?tab=${encodeURIComponent(tab)}` : base;
};

export const roomEditPath = (roomId) => `/rooms/${encodeURIComponent(String(roomId))}/edit`;

export const paymentLinkPublicPath = (token) => `/pay/${encodeURIComponent(String(token))}`;

export const userDetailPath = (userId) => `/users/${encodeURIComponent(String(userId))}`;
export const userEditPath = (userId) => `/users/${encodeURIComponent(String(userId))}/edit`;
